import React, {Component} from "react";
import CdmLayout from "../../../templates/cdm";
import _ from "lodash";
import current_tasks from "../../json/current_tasks";
import {NavLink} from "react-router-dom";
import ProgressBar from "../../elements/widgets/progress-bar";
import CalendarItem from "../../elements/calendar/calendar-item";
import placesList from "../../json/places";
import calendarList from "../../json/calendar";
import CalendarForm from "../../elements/calendar/calendar-form";

class CdmActivitiesCalendar extends Component {
	render() {
		let activity = _.find(current_tasks.data, {id: _.toInteger(this.props.match.params.id)});
		let step = _.find(activity.tasks, {id: _.toInteger(this.props.match.params.step)});
		return (<div className="columns is-multiline">
			<div className="column is-10 is-offset-1">
				<div className="column is-12">
					<div className="level">
						<NavLink to={`/cdm/tarea/${activity.id}`} className="button is-cdm-blue is-small"><i className="fa fa-arrow-left" style={{marginRight: '10px'}} /> Volver a la tarea</NavLink>
					</div>
				</div>
				<div className="column is-12">
					<div className="level cdm-header--dates">
						<div className="level-left">
							<div className="level-item">
								<p className="due-date">
									<span>Fecha límite</span>
									{step.date_finish}
								</p>
							</div>
						</div>
						<div className="level-right">
							<div className="level-item progress-detail">
								<ProgressBar total={100} detect={100} />
							</div>
						</div>
					</div>
					<div className={`cdm-header ${activity.category.style}`}>
						<div className="cdm-header--details">
							<p className="category">{activity.category.name}</p>
							<p>{step.duration} días</p>
						</div>
						<div className="cdm-header--title">
							<h1>{`${step.step}. ${step.title}`}</h1>
							<div className="modified">
								<p>
									<span>Última modificación</span>
									2018-08-16
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-12">
					 <CalendarForm places={placesList.data} nextId={this.state.calendar.detail} addEntry={this.addEntry} />
				</div>
				<div className="column is-12">
					<div className="field">
						<div className="control">
							<label htmlFor="finished" className="checkbox">
								<input type="checkbox" className="checkbox" id="finished" value="1" checked={ step.finished ? 'checked' : false} onChange={() => true} />
								He concluido esta tarea
							</label>
						</div>
					</div>
				</div>
				<hr/>
				<div className="column is-12">
					<div className="cdm-calendar-activities">
						{_.map(this.state.calendar.list, (cal, c) => {
							return <CalendarItem {...cal} place={_.find(placesList.data, {id: cal.place.id })} key={`calendar-item-${c}`} />
						})}
					</div>
				</div>
			</div>
		</div>)
	}

	constructor() {
		super();
		this.state = {
			calendar: {
				list: [...calendarList.data],
				detail: 3
			}
		}
		this.addEntry = this.addEntry.bind(this);
	}

	addEntry(event) {
		console.log('EVENT', event);
		return this.setState({
			...this.state,
			calendar: {
				...this.state.calendar,
				list: [
					...this.state.calendar.list,
					event
				]
			}
		});
	}
}

export default CdmLayout(CdmActivitiesCalendar, {
	title: 'Calendario de actividades',
	subnav: {
		icon: 'fa-calendar',
		name: 'Calendario',
		actions: [
		]
	},
	stateNav: true,
	progress: true
});


// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/substantial/calendar-activities.jsx